<template>
  <div>
    <h3>Entlastungstage (max. {{ maxReliefDays }})</h3>
    <div v-for="(day, index) in reliefDays" :key="index" class="relief-entry">
      <v-text-field
        v-model="reliefDays[index]"
        label="Datum"
        type="date"
        :min="minDate"
        :max="maxDate"
        :style="{ width: '200px' }"
        dense
        hide-details
        @change="emitChange"
      />
      <button @click="removeDay(index)"><v-icon color="primary">mdi-delete</v-icon></button>
    </div>
    <button v-if="reliefDays.length < maxReliefDays" @click="addDay"><v-icon color="primary">mdi-add</v-icon> Add Day</button>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, computed } from "vue"

export default defineComponent({
  name: "ReliefDaysInput",
  props: {
    modelValue: {
      type: Array as () => string[], // ISO-Datum-Strings
      default: () => [],
    },
    maxReliefDays: {
      type: Number,
      default: 0, // z. B. je nach Arbeitszeitmodell
    },
    startDate: {
      type: Date,
      default: () => new Date(), // Default to current date
    },
    endDate: {
      type: Date,
      default: () => new Date(), // Default to current date
    }
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const reliefDays = ref([...props.modelValue])
    const maxReliefDays = ref(props.maxReliefDays)

    const minDate = computed(() => props.startDate.toISOString().split("T")[0])
    const maxDate = computed(() => props.endDate.toISOString().split("T")[0])
    watch(() => props.modelValue, (newVal) => {
      reliefDays.value = [...newVal]
    })

    watch(() => props.maxReliefDays, (newVal) => {
      maxReliefDays.value = newVal
    })

    const emitChange = () => {
      emit("update:modelValue", reliefDays.value)
    }

    const addDay = () => {
      if (reliefDays.value.length < props.maxReliefDays) {
        reliefDays.value.push("")
        emitChange()
      }
    }

    const removeDay = (index: number) => {
      reliefDays.value.splice(index, 1)
      emitChange()
    }

    const ensureLength = () => {
      while (reliefDays.value.length < props.maxReliefDays) {
        reliefDays.value.push("")
      }
    }
    watch(() => props.maxReliefDays, ensureLength, { immediate: true })
    watch(() => props.modelValue, (newVal) => {
      reliefDays.value = [...newVal]
      ensureLength()
    })

    return {
      reliefDays,
      addDay,
      removeDay,
      emitChange,
      maxReliefDays,
      minDate,
      maxDate,
    }
  }
})
</script>

<style scoped>
.relief-entry {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}
</style>
